import { useEffect, useRef, useState } from 'react';

export interface SavedFlash {
  showing: boolean;
  trigger: () => void;
  hide: () => void;
}

/** "Saved" for a moment: the only thing that changes when a save changes nothing visible. */
export function useSavedFlash(durationMs: number): SavedFlash {
  const [showing, setShowing] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    [],
  );

  function hide() {
    if (timer.current) clearTimeout(timer.current);
    setShowing(false);
  }

  return {
    showing,
    hide,
    trigger: () => {
      setShowing(true);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setShowing(false), durationMs);
    },
  };
}
